var styles = {"Popover":"v1ShS1GPN1A-","inset":"xlCyOAcjM9Y-"};

export { styles as default };
//# sourceMappingURL=Popover.module.css.js.map
